import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';

import { deleteEmailNotification, getListAndCountAllNotificationEmail, setBranchList, updateStatusEmail } from '../../app/store/actions/notificationEmail';
import ModalComponent from '../../components/modal';
import TableRegisterButton from '../../components/table/registerButton';
import Table from '../../components/table/table';
import ROUTES from '../../data/routes';
import { history } from '../../routers/AppRouter';

class NotificationEmailPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 20,
      field: 'id',
      search: '',
      orderBy: 'DESC',
      showModal: false,
      titleModal: '',
      totalRecord: 0,
      titleModalBody: '',
      listNotificationEmail: [],
    };

    this.tableHeader = [
      { key: 'id', value: I18n.t('id') },
      { key: 'email', value: I18n.t('email') },
      { key: 'name', value: I18n.t('name') },
      { key: 'type', value: I18n.t('type') },
      { key: 'branchName', value: I18n.t('place') },
      { key: 'status', value: I18n.t('status') },
      { key: 'action', value: I18n.t('action') },
    ];
  }

  componentDidMount() {
    this.getListNotificationEmail(true);
  }

  typeTranslation = (type) => {
    const result = this.props.notificationEmailTypeList.find(elements => elements.type === type);
    return I18n.t((result && result.name) ? result.name : 'getnetPayment');
  }

  adjustData = async (count = 0, rows = []) => {
    const listNotificationEmail = rows.map((element, index) => ({
      key: index,
      id: element.id,
      email: element.email,
      name: element.name,
      type: this.typeTranslation(element.type),
      branchName: (element.branch && element.branch.crmTag) ? element.branch.crmTag : '',
      status: (
          <div className="row margin-left-0">
            <button
              type="button"
              className={`btn btn-${element.status === 'active' ? 'warning' : 'dark'} promotion-btn-${
                element.status === 'active' ? 'warning' : 'active'}`}
              onClick={() => this.activeEmailNotification(element.id, element.status === 'active' ? 'inactive' : 'active', element)}
            >
              <Translate value={element.status === 'active' ? 'disable' : 'active'} />
            </button>
          </div>
        ),
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {I18n.t('action')}
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => {
                  history.push({
                    pathname: ROUTES.FORM,
                    screenComming: 'NotificationEmailForm',
                    selected: element,
                  });
                }}
              >
                {I18n.t('edit')}
              </button>
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => this.deleteEmailNotificationModal(element.id)}
              >
                {I18n.t('delete')}
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    this.setState({
      totalRecord: count,
      listNotificationEmail,
    });
  }

  activeEmailNotification = async (id, status) => {
    try {
      await this.props.activeEmailNotification(id, status);
    } catch (error) {
      console.log(error)
    }
    await this.getListNotificationEmail(true)
  }
  
  deleteEmailNotificationModal = async (emailId) => {
    await this.setState({
      selectItemToDelete: emailId,
      showModal: true,
    });
  }

  deleteEmailNotification = async () => {
    const { selectItemToDelete } = this.state;
    console.log(selectItemToDelete)

    if (selectItemToDelete) {
      await this.props.deleteEmailNotification(selectItemToDelete);
      await this.setState({ selectItemToDelete: undefined, showModal: false });
      await this.getListNotificationEmail(true)
    }
  }

  getListNotificationEmail = async (firstRun = false) => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    try {
      const { count = 0, rows = [], branchList = [] } = await this.props.getListAndCountAllNotificationEmail(
        limit, skip, search, orderBy, field, firstRun,
      );
      if (firstRun) this.props.setBranchList(branchList);
      await this.adjustData(count, rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = error.code && error.details
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  };

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getListNotificationEmail();
  };

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getListNotificationEmail();
  };

  tableButtons = () => (
    <React.Fragment>
      <TableRegisterButton
        route={{ pathname: ROUTES.FORM, screenComming: 'NotificationEmailForm' }}
      />
    </React.Fragment>
  );

  render() {
    const {
      limit, page, listNotificationEmail, totalRecord,
      titleModal, titleModalBody, showModal,
    } = this.state;

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={I18n.t('delete')}
          body="Deseja realmente excluir o Correo Eletrónico?"
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('confirm')}
          size={{ width: '300px' }}
          showButtons
          showCancel
          confirmModal={this.deleteEmailNotification}
        />
        <Table
          page={page}
          count={totalRecord || 0}
          lines={listNotificationEmail}
          title={I18n.t('notificationEmail')}
          header={this.tableHeader}
          buttons={this.tableButtons()}
          perPage={limit}
          sortTable={this.sortTable}
          searchItems={this.searchTable}
          showItemsCount
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getListAndCountAllNotificationEmail: (limit, skip, search, orderBy, field, firstRun) => dispatch(
    getListAndCountAllNotificationEmail(limit, skip, search, orderBy, field, firstRun),
  ),
  setBranchList: branchList => dispatch(setBranchList(branchList)),
  activeEmailNotification: (id, status) => dispatch(updateStatusEmail(id, status)),
  deleteEmailNotification: id => dispatch(deleteEmailNotification(id)),
});

const mapStateToProps = state => ({
  notificationEmailTypeList: state.notificationEmail.notificationEmailTypeList,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationEmailPage);
